module.exports = __webpack_public_path__ + "static/media/m1_sf_9.f47d26a3.png";